import { resolveMermaidTheme } from './markdownPreviewRender';

type MermaidApi = typeof import('mermaid').default;

let mermaidPromise: Promise<MermaidApi> | null = null;
let lastTheme: 'dark' | 'default' | null = null;
let renderSeq = 0;

async function loadMermaid(): Promise<MermaidApi> {
  if (!mermaidPromise) {
    mermaidPromise = import('mermaid').then((mod) => mod.default);
  }
  return mermaidPromise;
}

export async function ensureMermaidInitialized(theme?: 'dark' | 'default'): Promise<MermaidApi> {
  const mermaid = await loadMermaid();
  const nextTheme = theme ?? resolveMermaidTheme();
  if (lastTheme !== nextTheme) {
    mermaid.initialize({
      startOnLoad: false,
      securityLevel: 'strict',
      theme: nextTheme
    });
    lastTheme = nextTheme;
  }
  return mermaid;
}

/** Renders Mermaid source to an SVG string using the current (or given) theme. */
export async function renderMermaidSvg(
  source: string,
  theme?: 'dark' | 'default'
): Promise<string> {
  const trimmed = source.trim();
  if (!trimmed) throw new Error('Empty Mermaid diagram.');

  const mermaid = await ensureMermaidInitialized(theme);
  const id = `jarvis-mermaid-${++renderSeq}-${Date.now().toString(36)}`;
  const { svg } = await mermaid.render(id, trimmed);
  return svg;
}

/** Test helper: reset cached theme so tests can assert re-init. */
export function resetMermaidRendererForTests(): void {
  lastTheme = null;
  mermaidPromise = null;
  renderSeq = 0;
}
